var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import ZhiXing from "~/components/system-tools/court-info-inquiry/zhixing.vue";
import ShiXin from "~/components/system-tools/court-info-inquiry/shixin.vue";
import XianGao from "~/components/system-tools/court-info-inquiry/xiangao.vue";
import XianChu from "~/components/system-tools/court-info-inquiry/xianchu.vue";
import CaiPan from "~/components/system-tools/court-info-inquiry/caipan.vue";
import ShenPan from "~/components/system-tools/court-info-inquiry/shenpan.vue";
import ZuiFan from "~/components/system-tools/court-info-inquiry/zuifan.vue";
import WeiFa from "~/components/system-tools/court-info-inquiry/weifa.vue";
import QianShui from "~/components/system-tools/court-info-inquiry/qianshui.vue";
import FeiZheng from "~/components/system-tools/court-info-inquiry/feizheng.vue";
import ZhongBen from "~/components/system-tools/court-info-inquiry/zhongben.vue";
import ZhiXingSf from "~/components/system-tools/court-info-inquiry/zhixingsf.vue";
import { SystemToolsService } from "~/services/domain-service/system-tools.service";
var SystemLog = /** @class */ (function (_super) {
    __extends(SystemLog, _super);
    function SystemLog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stypeList = [{
                stypeName: "自然人",
                stypeValue: 1
            }, {
                stypeName: "企业",
                stypeValue: 2
            }];
        _this.namePrompt = "姓名";
        _this.idPrompt = "身份证";
        _this.activeName = '';
        _this.queryParam = {
            stype: 1,
            name: "",
            id: ""
        };
        _this.queryDetailParam = {
            stype: 1,
            name: "",
            id: "",
            pageNum: 1,
            url: "",
            hfApiCallType: null
        };
        _this.zhixingIsReload = false;
        _this.shixinIsReload = false;
        _this.xiangaoIsReload = false;
        _this.xianchuIsReload = false;
        _this.caipanIsReload = false;
        _this.shenpanIsReload = false;
        _this.zuifanIsReload = false;
        _this.weifaIsReload = false;
        _this.qianshuiIsReload = false;
        _this.feizhengIsReload = false;
        _this.zhongbenIsReload = false;
        _this.zhixingsfIsReload = false;
        _this.riskInfoSummaryDefault = {
            zhixing: {
                num: 0,
                url: ""
            },
            shixin: {
                num: 0,
                url: ""
            },
            xiangao: {
                num: 0,
                url: ""
            },
            xianchu: {
                num: 0,
                url: ""
            },
            caipan: {
                num: 0,
                url: ""
            },
            shenpan: {
                num: 0,
                url: ""
            },
            zuifan: {
                num: 0,
                url: ""
            },
            weifa: {
                num: 0,
                url: ""
            },
            qianshui: {
                num: 0,
                url: ""
            },
            feizheng: {
                num: 0,
                url: ""
            },
            zhongben: {
                num: 0,
                url: ""
            },
            zhixingsf: {
                num: 0,
                url: ""
            },
        };
        _this.riskInfoSummary = _this.riskInfoSummaryDefault;
        return _this;
    }
    SystemLog.prototype.stypeChange = function () {
        if (2 === this.queryParam.stype) {
            this.namePrompt = "企业全称";
            this.idPrompt = "统一社会信用代码";
        }
        else {
            this.namePrompt = "姓名";
            this.idPrompt = "身份证";
        }
        this.queryParam.name = "";
        this.queryParam.id = "";
        this.riskInfoSummary = this.riskInfoSummaryDefault;
        this.setReloadFlag();
    };
    SystemLog.prototype.refreshData = function () {
        var _this = this;
        if (this.queryParam.name === "" || this.queryParam.id === "") {
            this.$alert(this.namePrompt + " 与 " + this.idPrompt + " 不能为空", "提示", {
                confirmButtonText: "确定"
            });
            return;
        }
        this.setReloadFlag();
        this.systemToolsService
            .queryRiskInfo(this.queryParam)
            .subscribe(function (data) {
            _this.riskInfoSummary = data;
        });
    };
    SystemLog.prototype.handleResetForm = function () {
        this.queryParam.stype = 1;
        this.queryParam.name = "";
        this.queryParam.id = "";
        this.stypeChange();
        this.riskInfoSummary = this.riskInfoSummaryDefault;
        this.setReloadFlag();
    };
    SystemLog.prototype.setReloadFlag = function () {
        this.activeName = "";
        this.zhixingIsReload = false;
        this.shixinIsReload = false;
        this.xiangaoIsReload = false;
        this.xianchuIsReload = false;
        this.caipanIsReload = false;
        this.shenpanIsReload = false;
        this.zuifanIsReload = false;
        this.weifaIsReload = false;
        this.qianshuiIsReload = false;
        this.feizhengIsReload = false;
        this.zhongbenIsReload = false;
        this.zhixingsfIsReload = false;
    };
    SystemLog.prototype.handleClick = function (tab, event) {
        var num = tab.$attrs.number;
        if (!num || num <= 0) {
            console.log("数量为0，退出");
            return;
        }
        var url = tab.$attrs.urlInfo;
        var riskType = tab.name;
        this.queryDetailParam.stype = this.queryParam.stype;
        this.queryDetailParam.name = this.queryParam.name;
        this.queryDetailParam.id = this.queryParam.id;
        this.queryDetailParam.pageNum = 1;
        this.queryDetailParam.url = url;
        this.queryDetailParam.hfApiCallType = riskType;
        switch (riskType) {
            case "ZHIXING":
                this.zhixingIsReload = true;
                break;
            case "SHIXIN":
                this.shixinIsReload = true;
                break;
            case "XIANGAO":
                this.xiangaoIsReload = true;
                break;
            case "XIANCHU":
                this.xianchuIsReload = true;
                break;
            case "CAIPAN":
                this.caipanIsReload = true;
                break;
            case "SHENPAN":
                this.shenpanIsReload = true;
                break;
            case "ZUIFAN":
                this.zuifanIsReload = true;
                break;
            case "WEIFA":
                this.weifaIsReload = true;
                break;
            case "QIANSHUI":
                this.qianshuiIsReload = true;
                break;
            case "FEIZHENG":
                this.feizhengIsReload = true;
                break;
            case "ZHONGBEN":
                this.zhongbenIsReload = true;
                break;
            case "ZHIXINGSF":
                this.zhixingsfIsReload = true;
                break;
            default:
                break;
        }
    };
    __decorate([
        Dependencies(SystemToolsService)
    ], SystemLog.prototype, "systemToolsService", void 0);
    SystemLog = __decorate([
        Auth(2401),
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                ZhiXing: ZhiXing,
                ShiXin: ShiXin,
                XianGao: XianGao,
                XianChu: XianChu,
                CaiPan: CaiPan,
                ShenPan: ShenPan,
                ZuiFan: ZuiFan,
                WeiFa: WeiFa,
                QianShui: QianShui,
                FeiZheng: FeiZheng,
                ZhongBen: ZhongBen,
                ZhiXingSf: ZhiXingSf
            }
        })
    ], SystemLog);
    return SystemLog;
}(Vue));
export default SystemLog;
